




import Class from './c-view';
export default Class;
